import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import RoundClose from 'react-md-icon/dist/RoundClose';
import theme from 'theme';

import { ToastContainer, ToastTitle, ToastMessage, CloseIcon } from './elements';

class ToastElement extends Component {
  state = {
    isGoingToBeRemoved: false,
  };

  componentDidMount = () => {
    this.startCounting();
  };

  componentDidUpdate = (_, prevState) => {
    const { isGoingToBeRemoved } = this.state;
    if (prevState.isGoingToBeRemoved !== isGoingToBeRemoved) {
      this.cancelCounting();
      setTimeout(this.remove, 300);
    }
  };

  cancelCounting = () => {
    clearTimeout(this.timeOut);
  };

  startCounting = () => {
    this.timeOut = setTimeout(() => {
      this.setState({ isGoingToBeRemoved: true });
    }, 6000);
  };

  remove = () => {
    const { removeElements } = this.props;
    const { isGoingToBeRemoved } = this.state;
    if (isGoingToBeRemoved) {
      removeElements();
    }
  };

  forceRemove = () => this.setState({ isGoingToBeRemoved: true });

  render() {
    const { type, title, message } = this.props;
    const { isGoingToBeRemoved } = this.state;

    return (
      <ToastContainer
        type={type}
        onClick={this.forceRemove}
        isGoingToBeRemoved={isGoingToBeRemoved}
      >
        <ToastTitle>{title}</ToastTitle>
        {message && <ToastMessage>{message}</ToastMessage>}
        <CloseIcon>
          <RoundClose />
        </CloseIcon>
      </ToastContainer>
    );
  }
}

const createToast = (type, title, message) => {
  const toastRoot = document.getElementById('toast');
  const toastElement = document.createElement('div');

  toastRoot.appendChild(toastElement);

  const removeElements = () => {
    ReactDOM.unmountComponentAtNode(toastElement);
    toastRoot.removeChild(toastElement);
  };

  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <ToastElement type={type} title={title} message={message} removeElements={removeElements} />
    </ThemeProvider>,
    toastElement,
  );
};

const toast = (title, message) => createToast('primary', title, message);
toast.success = (title, message) => createToast('success', title, message);
toast.info = (title, message) => createToast('info', title, message);
toast.error = (title, message) => createToast('danger', title, message);

ToastElement.defaultProps = {
  message: '',
};

ToastElement.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  removeElements: PropTypes.func.isRequired,
};

export default toast;
